export const portfolioItems = [
  {
    name: "absolute",
    year: "2022",
    category: "art",
    primary: require("@/assets/grid/absolute.png"),
    secondary: [require("@/assets/grid/absolute_.png")]
  },
  {
    name: "acid",
    year: "2021",
    category: "art",
    primary: require("@/assets/grid/acid.png"),
    secondary: [require("@/assets/grid/acid_.png")]
  },
  {
    name: "aethernet",
    year: "2020",
    category: ["video", "label"],
    primary: require("@/assets/grid/aethernet.jpg"),
    description: [
      { type: 'html', content: 'Aethernet by Fax Gang<br>Online album release party<br>Visualizers made for ' },
      { type: 'link', content: 'MIMIDEATH', href: 'https://youtu.be/rqN1PSC1Z1Y?si=CaXiY0CtBBBLOf8L' },
      { type: 'text', content: ' and ' },
      { type: 'link', content: 'Acetantina/Kaizo Slumber', href: 'https://youtu.be/_uGDQB4GIBw?si=aNcRX8UzLwmonCxj' }
    ]
  },
  {
    name: "april",
    title: "vessel pilot",
    year: "2022",
    category: "art",
    primary: require("@/assets/grid/april.png"),
    description: [
      { type: 'html', content: 'Vessel Pilot by Murrumur<br>Single cover art<br>' },
      { type: 'link', content: 'Listen', href: 'https://soundcloud.com/murrumur/vessel-pilot?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing' }
    ]
  },
  {
    name: "avenade",
    title: "vice versa",
    year: "2020",
    category: "video",
    primary: require("@/assets/grid/avenade.jpg"),
    description: "Vice Versa in Such Things by Avenade<br>Album visualiser",
    embedUrls: ["https://www.youtube.com/embed/eGcf9E7VS0o?si=mj8FrYbL05fmBcV0"]
  },
  {
    name: "avenTape",
    title: "whimsical afterlife",
    year: "2020",
    category: "label",
    primary: require("@/assets/grid/avenTape.jpg"),
    secondary: [require("@/assets/grid/avenTape_.jpg")],
    description: "It's a Whimsical Afterlife by Avenade<br>Released on tape via Eva Hakai",
  },
  {
    name: "bowel",
    title: "bowel lovement",
    year: "2019",
    category: "music",
    primary: require("@/assets/grid/bowel.jpg"),
    description: "Shit album I made in 2 weeks",
    bcembed: "2686267751"
  },
  {
    name: "bullet",
    title: "bite the bullet",
    year: "2022",
    category: "music",
    primary: require("@/assets/grid/bullet.png"),
    description: "Free improv sound collage album with Halina Rahdjian<br>Released on Next Year's Snow<br>An excerpt of this was also broadcast on BBC Radio apparently",
    bcembed: "3777107319"
  },
  {
    name: "carmen",
    title: "carmen winstead",
    year: "2021",
    category: ["video", "label"],
    primary: require("@/assets/grid/carmen.png"),
    description: "Visualizers made for Bliss3three and Cryosauna",
    embedUrls: ["https://www.youtube.com/embed/KDOtBLydD6Y"]
  },
  {
    name: "cryo",
    title: "teleport",
    year: "2022",
    category: ["video", "label"],
    primary: require("@/assets/grid/cryo.jpg"),
    description: "Teleport by Cryosauna<br>Album and single visualiser",
    embedUrls: ["https://www.youtube.com/embed/fQwn9JCd9AE", "https://www.youtube.com/embed/rwJzW4X47n4"]
  },
  {
    name: "dataprism",
    year: "2022",
    category: ["video", "label"],
    primary: require("@/assets/grid/dataprism.jpg"),
    description: "Dataprism by Fax Gang<br>Online album release party<br>Visualizer made for purity://filter"
  },
  {
    name: "djfuckedupfingers",
    title: "dj fucked up fingers",
    year: "2023",
    category: ["art", "etc"],
    primary: require("@/assets/grid/djfuckedupfingers.png"),
  },
  {
    name: "dreihand",
    title: "dreihänder",
    year: "2022",
    category: ["music", "art"],
    primary: require("@/assets/grid/dreihand.jpg"),
    bcembed: "1475199165"
  },
  {
    name: "eva1",
    title: "eva vol. 1",
    year: "2020",
    category: ["label", "music"],
    primary: require("@/assets/grid/eva1.jpg"),
    description: "Eva Vol. 1<br>First Eva Hakai label compilation<br>All proceedings were donated to the <a href='https://twocc.org/' target='_blank'>Trans Women of Color Collective</a> and <a href='https://www.theokraproject.com/' target='_blank'>The Okra Project</a>",
    bcembed: "4074698764"
  },
  {
    name: "evaGif",
    title: "Eva Hakai",
    year: "2020",
    category: "label",
    primary: require("@/assets/grid/evaGif.gif")
  },
  {
    name: "femtanyl",
    year: "2023",
    category: "label",
    primary: require("@/assets/grid/femtanyl.jpg"),
    description: "Chaser by Femtanyl<br>Released on tape via Eva Hakai",
  },
  {
    name: "flashkore",
    year: "2023",
    category: "art",
    primary: require("@/assets/grid/flashkore.png"),
    secondary: [require("@/assets/grid/flashkore_.png")]
  },
  {
    name: "flucc",
    title: "megaworld 2023",
    year: "2023",
    category: ["music", "live"],
    primary: require("@/assets/grid/flucc.jpg"),
    secondary: [require("@/assets/mqdefault_6s.webp")],
    description: "Live performance at Megaworld.xyz 360° festival 5/10/2023 @ Flucc Wien",
    embedUrls: ["https://www.youtube.com/embed/i34S4SZv8qE?si=DEKEtGdWxbRcMJGF"]
  },
  {
    name: "forbidden",
    year: "0̴̟͔̖͉͈͙̣̫͘͞͡͡0̸͕͎̫͉̘́͠0̵̸̢̖̩̠̳̼̞̻̹̝͙̣͚̦̫̘̝̦̀͠ͅ0̧͍̦̩̠̤̱̻̭͉̹͍̲͠ͅ",
    category: ["art", "etc"],
    primary: require("@/assets/grid/forbidden.png"),
  },
  {
    name: "gundam",
    year: "2022",
    category: "art",
    primary: require("@/assets/grid/gundam.png"),
    secondary: [require("@/assets/grid/gundam_.png")],
  },
  {
    name: "hoodie1",
    title: "hoodie",
    year: "2020",
    category: ["clothes", "label"],
    primary: require("@/assets/grid/hoodie1.png"),
    secondary: [require("@/assets/grid/hoodie1_.png")],
    description: "Eva Putrid Fuckin Disgusting Sewer Hoodie<br>Hand sown contemporary hooded cotton sweatshirt, size Large<br>Eviscerated with bleach, patched sleeves, spiked hood<br>1/1"
  },
  {
    name: "image",
    title: "baile",
    year: "2023",
    category: "live",
    primary: require("@/assets/grid/image.jpg"),
    description: "Distorted Baile mix performed along with Momo",
    embedUrls: ["https://www.youtube.com/embed/HRNZ5jP6A2s?si=x5IlThpKSUwDpcbE"]
  },
  {
    name: "itdoesntdoanything",
    year: "2022",
    category: "art",
    primary: require("@/assets/grid/itdoesntdoanything.png")
  },
  {
    name: "longsleeve1",
    title: "flannel longsleeve",
    year: "2021",
    category: ["clothes", "label"],
    primary: require("@/assets/grid/longsleeve1.png"),
    secondary: [require("@/assets/grid/longsleeve1_.png")],
    description: "Eva Flannel Longsleeve<br>Hand sown and stitched<br>Patched front<br>1/1"
  },
  {
    name: "magic",
    title: "magic for beginners",
    year: "2021",
    category: "music",
    primary: require("@/assets/grid/magic.jpg"),
    description: "Magic for Beginners by Murrumur<br>Production on track 6",
    bcembed: "2304555952"
  },
  {
    name: "mecha2022",
    title: "mechafest 2022",
    year: "2022",
    category: ["video", "label"],
    primary: require("@/assets/grid/mecha2022.jpg"),
    description: "Visualizers made for Cryosauna, Drixxo Lords and Kaizo Slumber<br><a href='https://twitter.com/themechafest/status/1539662980300025856' target='_blank'>More info</a>"
  },
  {
    name: "mechafest2021",
    title: "mechafest 2021",
    year: "2021",
    category: ["video", "label", "live"],
    primary: require("@/assets/grid/mechafest2021.jpg"),
    description: [
      { type: 'text', content: 'Visualizers made for ' },
      { type: 'link', content: 'nobodyis', href: 'https://youtu.be/ag5rp3sdnI4?si=B2-nnEiISYA0YsER' },
      { type: 'text', content: ', ' },
      { type: 'link', content: 'bliss3three', href: 'https://youtu.be/OofzFAxu08w?si=69Hat-hxFqQwkiFB' },
      { type: 'text', content: ', ' },
      { type: 'link', content: 'BROKEN_CANYON', href: 'https://youtu.be/cVPx1oxdGIE?si=1ZfOC-hrGAcHOm4F' },
      { type: 'text', content: ', Secret Webcam Girl, Prismadoll, Acetantina/Kaizo Slumber, ' },
      { type: 'link', content: 'MIMIDEATH', href: 'https://youtu.be/YKv3hB1s5bE?si=BVeOzRss-PiaRBtv' },
      { type: 'html', content: " and Mixed Matches<br>I performed there too<br><a href='https://twitter.com/themechafest/status/1369041200322383875' target='_blank'>More info</a>" }
    ]
  },
  {
    name: "mega22",
    title: "megaworld 2022",
    year: "2022",
    category: "live",
    primary: require("@/assets/grid/mega22.png"),
    description: "Live performance @ Megaworld.xyz festival 1/7/2022",
    embedUrls: ["https://www.youtube.com/embed/uY7Dyw1KcT4?si=AICBuaz2yyMnBWY2"]
  },
  {
    name: "murTape",
    title: "panic panic",
    year: "2020",
    category: "label",
    primary: require("@/assets/grid/murTape.png"),
    description: "Panic Panic by Mechanical Museum<br>Released on tape via Eva Hakai",
  },
  {
    name: "neuTape",
    title: "fluorescentnt art",
    year: "2020",
    category: "label",
    primary: [require("@/assets/grid/bong.jpg")],
    description: "Fluorescent Art by Neupink<br>Released on tape via Eva Hakai",
  },
  {
    name: "newluhas",
    title: "new luhas",
    year: "2021",
    category: "music",
    primary: require("@/assets/grid/newluhas.jpg"),
    description: "scraps",
    bcembed: "716679128"
  },
  {
    name: "notebook",
    primary: require("@/assets/grid/notebook.png")
  },
  {
    name: "panda",
    year: "2022",
    category: "art",
    primary: require("@/assets/grid/panda.png"),
    secondary: [require("@/assets/grid/panda_.png"), require("@/assets/grid/panda__.png")]
  },
  {
    name: "pomputer",
    year: "2022",
    category: "art",
    primary: require("@/assets/grid/pomputer.png"),
    secondary: [require("@/assets/grid/pomputer_.png"), require("@/assets/grid/pomputer__.png")]
  },
  {
    name: "quarantainment2",
    title: "quarantainment 2",
    year: "2021",
    category: ["live", "art"],
    primary: require("@/assets/grid/quarantainment2.jpg")
  },
  {
    name: "rust",
    year: "2021",
    category: "art",
    primary: require("@/assets/grid/rust.png"),
    secondary: [require("@/assets/grid/rust_.png")]
  },
  {
    name: "saya",
    year: "2021",
    category: "art",
    primary: require("@/assets/grid/saya.png"),
    secondary: [require("@/assets/grid/saya_.png")]
  },
  {
    name: "seaweed",
    title: "seaweed jesus",
    year: "2021",
    category: ["video", "label"],
    primary: require("@/assets/grid/seaweed.png"),
    description: "Seaweed Jesus by Neupink<br>Online album release party<br>Organisation & visuals by me<br>The original stream of this event has unfortunately been taken down",
    embedUrls: ["https://www.youtube.com/embed/FBLsN-XN8-U?si=brsWOt1myJAYI9uu"]
  },
  {
    name: "shirt1",
    title: "split striped shirt",
    year: "2020",
    category: ["clothes", "label"],
    primary: require("@/assets/grid/shirt1.png"),
    secondary: [require("@/assets/grid/shirt1_.png"), require("@/assets/grid/testcat.jpg")],
    description: "Eva Split Striped Shirt<br>Cut, sown and printed by hand<br>2/2"
  },
  {
    name: "shirt2",
    title: "basics 1",
    year: "2020",
    category: ["clothes", "label"],
    primary: require("@/assets/grid/shirt2.png"),
    secondary: [require("@/assets/grid/shirt2_.png"), require("@/assets/grid/virus.jpg"), require("@/assets/grid/virus2.jpg")]
  },
  {
    name: "shirt3",
    title: "basics 2",
    year: "2021",
    category: ["clothes", "label"],
    primary: require("@/assets/grid/shirt3.png"),
    secondary: [require("@/assets/grid/shirt3_.png"), require("@/assets/grid/fabi1.jpg"), require("@/assets/grid/fabi2.jpg")]
  },
  {
    name: "shirt4",
    title: "bliss3three shirt",
    year: "2021",
    category: ["clothes", "label"],
    primary: require("@/assets/grid/shirt4.png"),
    secondary: [require("@/assets/grid/shirt4_.png")],
    description: "Shirt designed for bliss3three under No Agreements<br>For the release of <a href='https://bliss3three.bandcamp.com/album/im-gonna-miss-you' target='_blank'>I'm Gonna Miss You</a>",
  },
  {
    name: "shirt5",
    title: "poor dog shirt",
    year: "2021",
    category: ["clothes", "label"],
    primary: require("@/assets/grid/shirt5.png"),
    description: "Shirt designed for No Agreements to go along with the No More Dead Dogs movie"
  },
  {
    name: "shirt6",
    title: "5ubaruu shirt",
    year: "2021",
    category: "clothes",
    primary: require("@/assets/grid/shirt6.png"),
    secondary: [require("@/assets/grid/shirt6_.png"), require("@/assets/grid/subshirt.jpeg")],
    description: "Shirt designed and printed for 5ubaruu<br><a href='https://5ubaruu.bandcamp.com/merch/5ubaruu-blue-on-black-t-shirt' target='_blank'>Link</a>",
  },
  {
    name: "shirt7",
    title: "dog shirt",
    year: "2022",
    category: ["clothes", "label", "art"],
    primary: require("@/assets/grid/shirt7.png"),
    secondary: [require("@/assets/grid/shirt7_.png"), require("@/assets/grid/dog.png"), require("@/assets/grid/abdi.jpg")]
  },
  {
    name: "slumber",
    title: "kaizo manifesto",
    year: "2022",
    category: ["video", "label"],
    primary: require("@/assets/grid/slumber.jpg"),
    description: "The Kaizo Manifesto by Kaizo Slumber<br>Online album release party<br>Visualizer made for Yesterdayneverhappened",
    embedUrls: ["https://www.youtube.com/embed/bvyf2kZ03kQ?si=BkfYGbS9RuGX_rK1"]
  },
  {
    name: "soul",
    title: "soul seizer",
    year: "2019",
    category: "music",
    primary: require("@/assets/grid/soul.jpg"),
    description: "Black metal/grindcore EP I made",
    bcembed: "2134831713"
  },
  {
    name: "sp404",
    year: "2022",
    category: "art",
    primary: require("@/assets/grid/sp404.png")
  },
  {
    name: "ss",
    title: "static swords",
    year: "2016",
    category: "etc",
    primary: require("@/assets/grid/ss.jpg"),
    description: "<a href='https://www.youtube.com/channel/UCqw-nFmbmhogQRcIugzVP5A/videos' target='_blank'>2016 - 2020</a>"
  },
  {
    name: "swordflower",
    year: "2020",
    category: "music",
    primary: require("@/assets/grid/swordflower.jpg"),
    description: "Swordflower Hills Killer by Neupink<br>Feature on track 3",
    bcembed: "2227384405"
  },
  {
    name: "thing",
    year: "2022",
    category: "art",
    primary: require("@/assets/grid/thing.png"),
    secondary: [require("@/assets/grid/thing_.png")]
  },
  {
    name: "webmaker",
    year: "2021",
    category: "music",
    primary: require("@/assets/grid/webmaker.jpg"),
    description: "Webmaker by Murrumur<br>Feature on track 6",
    bcembed: "603085998"
  },
  {
    name: "yena",
    year: "xxxx",
    category: ["art", "etc"],
    primary: require("@/assets/grid/yena.png"),
    secondary: [require("@/assets/grid/yena_.png")]
  },
  {
    name: "sewing",
    year: "2024",
    category: "video",
    primary: require("@/assets/grid/sewing.gif"),
    secondary: [require("@/assets/grid/sewshot.png")],
    description: "Sewing Up Their Skin by Murrumur<br>Album visualiser",
    embedUrls: ["https://www.youtube.com/embed/cpE_zwmmFIk?si=_MsGDncP_wsVliDF"]
  },
  {
    name: "visoki napon",
    year: "2024",
    category: "art",
    primary: require("@/assets/grid/visoki napon.jpg"),
    secondary: [require("@/assets/grid/visoki napon_.jpg"), require("@/assets/grid/visoki napon__.jpg")]
  },
  {
    name: "netcronomicon",
    title: "Netcronomicon",
    year: "2025",
    category: "etc",
    primary: require("@/assets/grid/netcro.png")
  },
  {
    name: "watch a stone age",
    year: "2025",
    category: "art",
    primary: require("@/assets/grid/stone1.jpg"),
    secondary: [require("@/assets/grid/stone2.jpg"), require("@/assets/grid/stone3.jpg"), require("@/assets/grid/stone4.jpg"), require("@/assets/grid/stone5.jpg")],
    description: "<h1>Watch a Stone Age</h1><br>A granite stone, interconnected with sensors and technology, is algorithmically analyzed to calculate its metaphorical 'lifespan.' Visitors can experience the subtle reactions of the installation through light, visuals, and data, influenced by touch and environmental factors. The project invites contemplation on the discrepancy between geological time and human perception."
  },
  {
    name: "3dworld",
    title: "3dworld",
    year: "2025",
    category: "etc"
  },
];